var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 28,
    viewBox: "0 0 32 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0312 11.9772C11.0312 11.9772 4.03123 19.6756 4.03123 24.5576C4.03123 26.7482 5.65623 28 8.46873 28C11.5312 28 13.5312 26.4353 16.0312 26.4353C18.4687 26.4353 20.4687 28 23.5312 28C26.3437 28 28.0312 26.7482 28.0312 24.5576C28.0312 19.6756 20.9687 11.9772 16.0312 11.9772ZM6.78123 11.2261C6.15623 9.0355 4.15623 7.65854 2.34373 8.09666C0.531233 8.53478 -0.468767 10.6002 0.218733 12.7908C0.843733 14.9815 2.84373 16.3584 4.65623 15.9203C6.46873 15.4822 7.46873 13.4167 6.78123 11.2261ZM12.0937 9.91175C14.0312 9.41103 14.9687 6.78229 14.2812 4.09096C13.5312 1.33704 11.3437 -0.415459 9.40623 0.0852541C7.46873 0.585967 6.53123 3.21471 7.21873 5.90604C7.96873 8.65996 10.1562 10.4125 12.0937 9.91175ZM29.6562 8.09666C27.8437 7.65854 25.8437 9.0355 25.2187 11.2261C24.5312 13.4167 25.5312 15.4822 27.3437 15.9203C29.1562 16.3584 31.1562 14.9815 31.7812 12.7908C32.4687 10.6002 31.4687 8.53478 29.6562 8.09666ZM19.9062 9.91175C21.8437 10.4125 24.0312 8.65996 24.7812 5.90604C25.4687 3.21471 24.5312 0.585967 22.5937 0.0852541C20.6562 -0.415459 18.4687 1.33704 17.7187 4.09096C17.0312 6.78229 17.9687 9.41103 19.9062 9.91175Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaw);
export default __webpack_public_path__ + "static/media/paw.328e49841aff32038a84227f8165d4e3.svg";
export { ForwardRef as ReactComponent };